import { useEffect, useState } from 'react';
import { Modal, Checkbox, Button } from 'antd';
import { RoleModulesMapping, SnpModule } from '../../../shared/RoleBasedTypes';
import {
	RoleBasedModules,
	UserRole,
} from '../../../shared/VolunteerApplicationServiceTypes';

interface Props {
	open: boolean;
	onClose: () => void;
	modules: SnpModule[];
	roleCode: string | undefined;
	roleName: string | undefined;
	allRolesWithModules: RoleModulesMapping[] | null;
	onSave: (payload: { roleCode: string; moduleIds: number[] }) => Promise<void>;
}

export const UpdateRoleModules = ({
	open,
	onClose,
	modules,
	roleCode,
	roleName,
	allRolesWithModules,
	onSave,
}: Props) => {
	const [selectedModuleIds, setSelectedModuleIds] = useState<number[]>([]);

	useEffect(() => {
		if (!roleCode) return;

		const roleData = allRolesWithModules?.find((r) => r.role.code === roleCode);

		if (roleData) {
			const activeModuleIds = roleData.modules
				.filter((m) => m.roleModuleMappingStatus === 'ACTIVE')
				.map((m) => m.module.id);

			setSelectedModuleIds(activeModuleIds);
		}
	}, [roleCode, allRolesWithModules]);

	const onChange = (checkedValues: number[]) => {
		setSelectedModuleIds(checkedValues);
	};

	const handleSave = async () => {
		if (!roleCode || !onSave) return;

		await onSave({
			roleCode,
			moduleIds: selectedModuleIds,
		});

		onClose();
	};

	return (
		<Modal
			title={`Select Modules for Role: ${roleName || ''}`}
			open={open}
			onCancel={onClose}
			centered
			width={700}
			footer={[
				<Button key="cancel" onClick={onClose}>
					Cancel
				</Button>,
				<Button key="save" type="primary" onClick={() => void handleSave()}>
					Save
				</Button>,
			]}
		>
			<Checkbox.Group
				value={selectedModuleIds}
				onChange={onChange}
				className="grid grid-cols-2 gap-4 mt-4"
			>
				{modules
					.filter((module) => {
						if (
							module.code === RoleBasedModules.MANAGE_PRIVILEGES_MODULE ||
							module.code === RoleBasedModules.MANAGE_FUNCTIONARIES_MODULE
						) {
							return false;
						}
						if (
							(roleCode === UserRole.NPS_ADMIN ||
								roleCode === UserRole.PREWORK_ADMIN) &&
							module.code === RoleBasedModules.SCREENING_MODULE
						) {
							return false;
						}

						return true;
					})
					.map((module) => (
						<Checkbox key={module.id} value={module.id}>
							{module.name}
						</Checkbox>
					))}
			</Checkbox.Group>
		</Modal>
	);
};
